import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, retry, tap } from 'rxjs/operators'
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { InternalService } from "./internal.service";
import { resolveCompanySectionOrder } from 'src/app/common/company-section-order';
// import { CustomMenu, HiddenResource } from "../models/custom-menu.interface";
// import { FullMenu } from "../models/full-menu.interface";
// import { FullUser } from "../models/full-user.interface";
// import { Rol } from "../models/roles.interface";
// import { User, UserMe } from "../models/user.interface";

@Injectable()
export class UserService extends InternalService {
    constructor(
        http: HttpClient, 
        router: Router,
        authService: AuthService
        ){
            super(http, router, authService);
        }

    login (data: any) {
        return this.http
            .post(`${environment.apiUrl}/login/`, data)
            .pipe(
                tap((response: any) => {
                    localStorage.setItem('token', JSON.stringify(response.token));
                    this.me().subscribe((me: any) => {
                        const orderedCompanies = me?.companies?.length > 0
                          ? resolveCompanySectionOrder(me.companies[0], me.companies[0].pages)
                          : [];
                        Promise.all([
                            this.authService.validateURL(me),
                        ]);
                        this.authService.tagService(
                          me.id,
                          me.first_name+' '+me.last_name,
                          me.companies[0].id,
                          me.companies[0].name,
                          orderedCompanies[0]?.id,
                          orderedCompanies[0]?.nombre,
                          "login"
                        ).subscribe()
                    });
                }),
                catchError(this.handleError.bind(this))
            )
    }

    checkUser(user_id, token) {
        return this.http
            .get(`${environment.apiUrl}/validation/check-user/?user_id=${user_id}&rpt=${token}`)
            .pipe(
                tap((response: any) => {
                    console.log('response', response);
                }),
                catchError(this.handleError.bind(this))
            )
    }
    validateEmail(data: any) {
        return this.http
            .post(`${environment.apiUrl}/validation/user-validation/`, data)
            .pipe(
                tap((response: any) => {
                    console.log('response', response);
                }),
                catchError(this.handleError.bind(this))
            )
    }

    me(): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.get(`${environment.apiUrl}/user/me/`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    allUsers(params?): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.get(`${environment.apiUrl}/user/${params}`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    getUser(id: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.get(`${environment.apiUrl}/user/${id}/`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }
    createMultipleUsers(data: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.post(`${environment.apiUrl}/multiusers/`, data, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    createUser(data: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.post(`${environment.apiUrl}/user/`, data, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }
    editUser(id: any, data: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.patch(`${environment.apiUrl}/user/${id}/`, data, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }
    deleteUser(id: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.delete(`${environment.apiUrl}/user/?user_id=${id}`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    // Admin user services
    getDashboardsOptions(): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.get(`${environment.apiUrl}/admin-users/get-dashboards-options/`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }
    getRestrictedDataOptions( page: Number, company_id: string, sub_service_dashboard: string ): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        let params = `?page=${page}&company_id=${company_id}&sub_service_dashboard=${sub_service_dashboard}`;
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.get(`${environment.apiUrl}/admin-users/get-restricted-data-options/${params}`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }
    getUserRestrictedData(user_id: string): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.get(`${environment.apiUrl}/admin-users/user-restricted-data/?user_id=${user_id}`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }
    postRestrictedDataUser(data: any): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.post(`${environment.apiUrl}/admin-users/user-restricted-data/`, data, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }
    
    // ─── ROLES DE EMPRESA (seccion Usuarios del cliente) ──────────────────────
    // A diferencia de los servicios de datos de Pan y Miel, estos usan el token
    // de sesion del usuario (environment.apiUrl) y no un APIToken de servicio:
    // el backend decide si quien llama es administrador de la empresa, y con un
    // token compartido no podria distinguirlo.
    private authHeaders(): HttpHeaders {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        return new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
    }

    getCompanySections(company_id: string): Observable<any> {
        return this.http
            .get(`${environment.apiUrl}/company-roles/sections/?company_id=${company_id}`, { headers: this.authHeaders() })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getCompanyRoles(company_id: string): Observable<any> {
        return this.http
            .get(`${environment.apiUrl}/company-roles/roles/?company_id=${company_id}`, { headers: this.authHeaders() })
            .pipe(catchError(this.handleError.bind(this)));
    }

    saveCompanyRole(data: any): Observable<any> {
        // data: { company_id, id?, name, description?, is_active?, permissions: [{page_id, access}] }
        // `permissions` reemplaza por completo la matriz anterior del rol.
        return this.http
            .post(`${environment.apiUrl}/company-roles/roles/`, data, { headers: this.authHeaders() })
            .pipe(catchError(this.handleError.bind(this)));
    }

    /** Marca el rol predeterminado de la empresa; `role_id` nulo la deja sin ninguno. */
    setDefaultCompanyRole(company_id: string, role_id: string | null): Observable<any> {
        return this.http
            .post(`${environment.apiUrl}/company-roles/role-default/`, { company_id, role_id }, { headers: this.authHeaders() })
            .pipe(catchError(this.handleError.bind(this)));
    }

    deleteCompanyRole(company_id: string, id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/company-roles/roles/`, { headers: this.authHeaders(), body: { company_id, id } })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getCompanyUsers(company_id: string): Observable<any> {
        return this.http
            .get(`${environment.apiUrl}/company-roles/users/?company_id=${company_id}`, { headers: this.authHeaders() })
            .pipe(catchError(this.handleError.bind(this)));
    }

    assignCompanyRole(company_id: string, user_id: string, role_id: string | null): Observable<any> {
        return this.http
            .post(`${environment.apiUrl}/company-roles/role-assignment/`, { company_id, user_id, role_id }, { headers: this.authHeaders() })
            .pipe(catchError(this.handleError.bind(this)));
    }

    tagService(user_id, user_name,company_id, company_name,page_id, page_name,interaction_type): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const data = {
            "user_id": user_id,
            "user_name": user_name,
            "Company id": company_id,
            "Company name": company_name,
            "Page id": page_id,
            "Page name": page_name,
            "Interactiontype": interaction_type
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.post(`${environment.apiUrl}/tagRegister/`, data, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }
    
    getAllTags(): Observable<any> {
        let token = localStorage.getItem('token');
        if (token) {
            token = JSON.parse(token);
        }
        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token || '');
        return this.http.get(`${environment.apiUrl}/tagRegister/`, {headers})
            .pipe(catchError(this.handleError.bind(this)));
    }

    // private handleError (error: HttpErrorResponse) {
    //     let publicPages = ['/login', '/auth/complete-registration'];
    //     const currentPage = this.router.url
    //     let currentPageValue
    //     if (this.router.url.includes('?')) {
    //         currentPageValue = currentPage.split('?')[0]
    //     }
    //     if (error.error instanceof ErrorEvent) {
    //         console.error('An error occurred:', error.error.message)
    //     } else if (publicPages.includes(currentPageValue)) {
    //         console.error('An error occurred:', error.error.message)
    //     } else {
    //         console.error(`Backend returned code ${error.status}, ` + `body was:`)
    //         console.error(error)
    //         if (error.status === 401) {
    //             this.authService.logout();
    //             this.router.navigate(['/login']);
    //         }
    //     }
    //     return throwError({
    //         message: 'Something bad happened; please try again later.',
    //         code: error.status
    //     })
    // }
}
